import { Action, UnknownAction } from 'redux';
import IDeal, {
    IDealErrors,
} from '@/Api/Deal/IDeal';
import IDealProperty, {
    IDealPropertyErrors,
} from '@/Api/Deal/IDealProperty';
import IDealQuote from '@/Api/Deal/IDealQuote';
import LeadActionsEnum from './ActionsEnum';
import IAddressSearchResult from '@/Api/AddressSearch/IAddressSearchResult';

export interface IDealAddAction extends Action<LeadActionsEnum.DealAdd> {
    successUrl: string;
}

export function dealAddAction(successUrl: string): IDealAddAction {
    return {
        successUrl,
        type: LeadActionsEnum.DealAdd,
    };
}

export interface IDealCompleteAction extends Action {
    autoQuote: boolean;
    quoteUrl: string;
    supportingDocuments: FileList;
    thanksUrl: string;
}

export function dealCompleteAction(autoQuote: boolean, thanksUrl: string, quoteUrl?: string, supportingDocuments?: FileList): IDealCompleteAction {
    return {
        autoQuote,
        quoteUrl,
        supportingDocuments,
        thanksUrl,
        type: LeadActionsEnum.DealComplete,
    };
}

export interface IDealErrorSetAction extends UnknownAction {
    field: keyof IDealErrors;
    value: string;
}

export function dealErrorSetAction(field: keyof IDealErrors, value: string): IDealErrorSetAction {
    return {
        field,
        type: LeadActionsEnum.DealErrorSet,
        value,
    };
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IDealGetAction extends Action {}

export function dealGetAction(): IDealGetAction {
    return {
        type: LeadActionsEnum.DealGet,
    };
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IDealSendAction extends Action {}

export function dealSendAction(): IDealSendAction {
    return {
        type: LeadActionsEnum.DealSend,
    };
}

export interface IDealSetAction extends Action {
    deal: IDeal;
}

export function dealSetAction(deal: IDeal): IDealSetAction {
    return {
        deal,
        type: LeadActionsEnum.DealSet,
    };
}

export interface IDealValueSetAction extends Action {
    key: keyof IDeal;
    value: boolean|number|string;
}

export function dealValueSetAction(key: keyof IDeal, value: boolean|number|string): IDealValueSetAction {
    return {
        key,
        type: LeadActionsEnum.DealValueSet,
        value,
    };
}

export interface IDealQuotesListAction extends Action {
    dealUuid: string;
}

export function dealQuotesListAction(dealUuid: string): IDealQuotesListAction {
    return {
        dealUuid,
        type: LeadActionsEnum.DealQuotesList,
    };
}

export interface IDealQuotesSetAction extends Action {
    quotes: IDealQuote[];
}

export function dealQuotesSetAction(quotes: IDealQuote[]): IDealQuotesSetAction {
    return {
        quotes,
        type: LeadActionsEnum.DealQuotesSet,
    };
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IPropertyAddAction extends Action {}

export function propertyAddAction(): IPropertyAddAction {
    return {
        type: LeadActionsEnum.PropertiesAdd,
    };
}

export interface IPropertyDeleteAction extends Action {
    uuid: string;
}

export function propertyDeleteAction(uuid: string): IPropertyDeleteAction {
    return {
        type: LeadActionsEnum.PropertyDelete,
        uuid,
    };
}

export interface IPropertyErrorSetAction extends Action {
    field: keyof IDealPropertyErrors;
    uuid: string;
    value: string;
}

export function propertyErrorSetAction(uuid: string, field: keyof IDealPropertyErrors, value: string): IPropertyErrorSetAction {
    return {
        field,
        type: LeadActionsEnum.PropertyErrorSet,
        uuid,
        value,
    };
}

export interface IPropertySendAction extends Action {
    uuid: string;
}

export function propertySendAction(uuid: string): IPropertySendAction {
    return {
        type: LeadActionsEnum.PropertySend,
        uuid,
    };
}

export interface IPropertySetAction extends Action {
    property: IDealProperty;
}

export function propertySetAction(property: IDealProperty): IPropertySetAction {
    return {
        property,
        type: LeadActionsEnum.PropertySet,
    };
}

export interface IPropertyValueSetAction extends Action {
    field: keyof IDealProperty;
    uuid: string;
    value: string;
}

export function propertyValueSetAction(uuid: string, field: keyof IDealProperty, value: string): IPropertyValueSetAction {
    return {
        field,
        type: LeadActionsEnum.PropertyValueSet,
        uuid,
        value,
    };
}

export interface IDealPropertyGnafAddressDetailAction extends Action {
    gnafAddressDetailPid: string;
    propertyUuid: string;
}

export function dealPropertyGnafAddressDetailAction(propertyUuid: string, gnafAddressDetailPid: string): IDealPropertyGnafAddressDetailAction {
    return {
        gnafAddressDetailPid,
        propertyUuid,
        type: LeadActionsEnum.PropertyGnafAddressDetail,
    };
}

type IDealPropertyGnafAddressDetailLoadingClearAction = Action<LeadActionsEnum.PropertyGnafAddressDetailLoadingClear>;

export function dealPropertyGnafAddressDetailLoadingClearAction(): IDealPropertyGnafAddressDetailLoadingClearAction {
    return {
        type: LeadActionsEnum.PropertyGnafAddressDetailLoadingClear,
    };
}

export interface IDealAddressSearchAction extends Action {
    keyword: string;
}

export function dealAddressSearchAction(keyword: string): IDealAddressSearchAction {
    return {
        keyword,
        type: LeadActionsEnum.DealAddressSearch,
    };
}

export interface IDealAddressSearchResultsSetAction extends Action {
    searchResults: IAddressSearchResult[];
}

export function dealAddressSearchResultsSetAction(searchResults: IAddressSearchResult[]): IDealAddressSearchResultsSetAction {
    return {
        searchResults,
        type: LeadActionsEnum.DealAddressSearchResultsSet,
    };
}

export type IDealAddressSearchResultsClearAction = Action<LeadActionsEnum.DealAddressSearchResultsClear>;

export function dealAddressSearchResultsClearAction(): IDealAddressSearchResultsClearAction {
    return {
        type: LeadActionsEnum.DealAddressSearchResultsClear,
    };
}
